export default __webpack_public_path__ + "static/media/gf_logo.97daf798.png";